import type { FormEvent } from 'react';

interface Props {
  email: string;
  loading: boolean;
  onEmailChange: (value: string) => void;
  onSubmit: (e: FormEvent) => void;
  onSwitchView: (view: 'login') => void;
}

export default function ForgotPasswordForm({
  email,
  loading,
  onEmailChange,
  onSubmit,
  onSwitchView,
}: Props) {
  return (
    <form onSubmit={onSubmit} className="auth-form">
      <div>
        <h2>Reset password</h2>
        <p className="auth-subtitle">We'll send you a reset code</p>
      </div>
      <div className="field">
        <label className="field-label" htmlFor="forgot-email">
          Email
        </label>
        <input
          id="forgot-email"
          className="input"
          type="email"
          value={email}
          onChange={(e) => onEmailChange(e.target.value)}
          required
          autoComplete="email"
          placeholder="you@company.com"
        />
      </div>
      <button type="submit" className="btn btn-primary" disabled={loading}>
        {loading ? 'Sending...' : 'Send Reset Code'}
      </button>
      <div className="auth-links">
        <button type="button" className="link-btn" onClick={() => onSwitchView('login')}>
          Back to sign in
        </button>
      </div>
    </form>
  );
}
